if (!customElements.get('part-finder')) {
  customElements.define(
    'part-finder',
    class PartFinder extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.selectCollection = this.querySelector('select.part-finder__select-collection');
        this.selectFilters = this.querySelectorAll('select.part-finder__select-filter');
        this.setupEventListeners();

        // There's no collection dropdown so we either need to populate
        // the filters of the entire store or the single collection chosen
        // (if only one collection has been chosen).
        (!this.selectCollection) && this.renderFiltersFromFetch(0, false);
      }

      setupEventListeners() {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          window.location = this.form.getAttribute('action');
        });
        this.selectCollection?.addEventListener('change', this.onCollectionChange.bind(this));
        this.selectFilters.forEach(event => event.addEventListener('change', this.onFilterChange.bind(this)));
      }

      onCollectionChange() {
        this.selectFilters.forEach((select) => {
          this.selectRemoveOptions(select);
          select.disabled = true;
        });

        this.renderFiltersFromFetch(0, true);
      }

      onFilterChange(event) {
        const selectedIndex = event.target.dataset.index;
        this.selectFilters.forEach((select) => {
          if (Number(select.dataset.index) <= Number(selectedIndex)) return;
          this.selectRemoveOptions(select);
          select.disabled = true;
        });

        this.renderFiltersFromFetch(selectedIndex, true);
      }

      renderFiltersFromFetch(selectedIndex = 0, disableButton) {
        const collectionUrl = this.updateURLHash();
        this.setFormUrl(collectionUrl.toString());
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        collectionUrl.searchParams.set('section_id', sectionId);

       disableButton && this.toggleSubmitButton(true);

        fetch(`${collectionUrl.pathname}${collectionUrl.search}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

            this.selectFilters.forEach((select) => {
              if (Number(select.dataset.index) <= Number(selectedIndex)) return;
              const options = parsedHTML.querySelectorAll(`select[name="${select.name}"] option:not(.default)`);

              if (options.length > 0) {
                const availableOptions = Array.from(options).filter(option => Number(option.dataset.count) > 0);
                select.append(...availableOptions);
                select.querySelector('option.default').selected = true;
              }

              if (Number(select.dataset.index) === Number(selectedIndex) + 1) select.disabled = false;
            });

            disableButton && this.toggleSubmitButton(false);
          })
          .catch((error) => {
            throw error;
          });
      }

      selectRemoveOptions(select) {
        const options = select.querySelectorAll('option:not(.default)');

        [...options].forEach((option) => select.removeChild(option));
        select.querySelector('option').selected = true;
      }

      updateURLHash() {
        const collectionUrl = this.selectCollection?.value ?? window.routes.all_products_collection_url;
        const url = new URL(collectionUrl, window.shopUrl);

        this.querySelectorAll('select.part-finder__select-filter:enabled').forEach((select) => {
          if (select.value === '') return;

          Array.from(select.selectedOptions).forEach((option) => url.searchParams.set(option.dataset.paramName, option.value));
        });

        return url;
      }

      setFormUrl(url) {
        this.form.setAttribute('action', url);
      }

      toggleSubmitButton(disable = true) {
        if (disable) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.classList.add('loading');
        } else {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
      }
    }
  );
}